export enum TipoValor {
  UNITARIO = <any> 'UNITARIO',
  MULTIVALORADO = <any> 'MULTIVALORADO'
}
